import { createTheme } from '@mui/material';

const theme = createTheme({
  // Your theme customization
});

export default theme;
